import React from 'react'
import {Col, FormGroup, Button} from 'react-bootstrap'
import {FaMagnet} from '../../../Common/ReactIcons/icons'
import {browserHistory} from 'react-router'

class AdPriceButtons extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isBellyVisible: !props.isMale,
      isMateVisible: props.isMale,
      hasEnoughPointFor: {sale: true, belly_rental: true, mate: true}
    }
    this.applyForAd = this.applyForAd.bind(this)
  }

  applyForAd (item) {
    if (this.props.prices[item] > this.props.points) {
      let update = this.state.hasEnoughPointFor
      update[item] = false
      this.setState({hasEnoughPointFor: update})
    } else {
      this.props.typeSetter('type', item.replace('_', '-'))
      this.props.submit()
    }
  }

  render () {
    const {prices} = this.props
    const {hasEnoughPointFor, isBellyVisible, isMateVisible} = this.state
    return (<FormGroup>
      {hasEnoughPointFor['sale'] ? <Col xsOffset={1} xs={5}>
        <Button className="btnBlock" bsStyle="success" onClick={() => this.applyForAd('sale')}>
            فروش <span><FaMagnet /> {prices.sale}</span>
        </Button>
      </Col>
        : <Col xsOffset={1} xs={5}>
          <Button className="btnBlock" bsStyle="success" onClick={() => browserHistory.push('/store')}>
            خرید نعل <span><FaMagnet /></span>
          </Button>
        </Col>}

      {isBellyVisible && (hasEnoughPointFor['belly_rental'] ? <Col xs={6}>
        <Button className="btnBlock" bsStyle="primary" onClick={() => this.applyForAd('belly_rental')}>
            اجاره شکم <span><FaMagnet /> {prices.belly_rental}</span>
        </Button>
      </Col>
        : <Col xsOffset={1} xs={5}>
          <Button className="btnBlock" bsStyle="primary" onClick={() => browserHistory.push('/store')}>
            خرید نعل <span><FaMagnet /></span>
          </Button>
        </Col>)}

      {isMateVisible && (hasEnoughPointFor['mate'] ? <Col xsOffset={1} xs={5}>
        <Button className="btnBlock" bsStyle="primary" onClick={() => this.applyForAd('mate')}>
          کشش <span><FaMagnet /> {prices.mate}</span>
        </Button>
      </Col>
        : <Col xsOffset={1} xs={5}>
          <Button className="btnBlock" bsStyle="primary" onClick={() => browserHistory.push('/store')}>
            خرید نعل <span><FaMagnet /></span>
          </Button>
        </Col>)}
    </FormGroup>)
  }
}

AdPriceButtons.propTypes = {
  isMale: React.PropTypes.bool,
  prices: React.PropTypes.object,
  points: React.PropTypes.number,
  submit: React.PropTypes.func,
  typeSetter: React.PropTypes.func
}

export default AdPriceButtons



// WEBPACK FOOTER //
// ./src/components/HorseInfo/HorseBreederOwner/AdBox/AdPriceButtons.js